import { REACT_APP_DEPLOY_ENV } from 'config';

/* eslint-disable no-console */
const say = (...args: any[]) => {
  if (REACT_APP_DEPLOY_ENV !== 'prod') console.log(...args);
};
const sayWarn = (...args: any[]) => {
  if (REACT_APP_DEPLOY_ENV !== 'prod') console.warn(...args);
};
const sayError = (...args: any[]) => {
  if (REACT_APP_DEPLOY_ENV !== 'prod') console.error(...args);
};

export { say, sayWarn, sayError };
